export function PageHeader({ eyebrow, title, desc, action }) {
  return (
    <div className="mb-8 flex flex-col gap-4 border-b border-welock-border pb-6 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="mt-3 font-heading text-2xl font-normal tracking-tight text-welock-textPrimary md:text-3xl">
          {title}
        </h1>
        {desc && <p className="mt-2 max-w-xl text-sm font-light text-welock-textSecondary">{desc}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, sub, accent, testId }) {
  return (
    <div className="border border-welock-border bg-welock-surface p-6" data-testid={testId}>
      <div className="font-mono text-[11px] uppercase tracking-widest text-welock-textMuted">{label}</div>
      <div className={`mt-3 font-heading text-2xl font-medium tracking-tight md:text-3xl ${accent ? "text-welock-accent" : "text-welock-textPrimary"}`}>
        {value}
      </div>
      {sub && <div className="mt-2 font-mono text-xs text-welock-textSecondary">{sub}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    active: { c: "text-welock-accent border-welock-accent/30 bg-welock-accent/5", label: "Active" },
    claimable: { c: "text-welock-warning border-welock-warning/30 bg-welock-warning/5", label: "Claimable" },
    unlocked: { c: "text-welock-textMuted border-welock-border bg-welock-bg", label: "Unlocked" },
  };
  const s = map[status] || map.active;
  return (
    <span className={`inline-flex items-center gap-1.5 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${s.c}`}>
      <span className="h-1 w-1 rounded-full bg-current" />
      {s.label}
    </span>
  );
}

const PRODUCT_LABEL = {
  "token-locker": "Token",
  "lp-locker": "LP",
  "vesting": "Vesting",
  "lp-vesting": "LP Vesting",
};

export function ProductTag({ product }) {
  return (
    <span className="font-mono text-[10px] uppercase tracking-wider text-welock-textMuted">
      {PRODUCT_LABEL[product] || product}
    </span>
  );
}
